import { render } from "./ChatMessage.vue?vue&type=template&id=c185018a"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/delano/projects/wp-dev/wp-content/plugins/wp-sam-chat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__